/* @flow */

import React from 'react';
import styled from 'styled-components';

type MessageProps = {
  messages: Array<string>,
};
type MessageState = {};

const MessageDiv = styled.div`
  cursor: none;
  margin: 50px;
  padding: 10px 50px;
  border: 2px solid white;
  border-radius: 20px;
  background-color: #000000a5;
`;

class Message extends React.Component<MessageProps, MessageState> {
  render() {
    return (
      <MessageDiv>
        {this.props.messages.map((m, i) => (
          <p key={'message-' + i}>{m}</p>
        ))}
      </MessageDiv>
    );
  }
}

const MessageContainerCenter = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export class MessageCenter extends React.Component<MessageProps, MessageState> {
  render() {
    return (
      <MessageContainerCenter>
        <Message messages={this.props.messages} />
      </MessageContainerCenter>
    );
  }
}

const MessageContainerTop = styled(MessageContainerCenter)`
  justify-content: flex-start;
`;

export class MessageTop extends React.Component<MessageProps, MessageState> {
  render() {
    return (
      <MessageContainerTop>
        <Message messages={this.props.messages} />
      </MessageContainerTop>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Message.js